<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :needEUDC="false"
            @removeService="removeService"
        >
            <template #content>
                <span
                    v-if="data.after.applyStatus"
                    class="text-lg"
                >
                    申請以您為要保人所投保之所有個人險有效及停效保單，<br class="hidden md:inline">申請後即取消紙本/單據寄發，改以電子郵件 (E-mail) 方式通知。
                </span>
                <span
                    v-else
                    class="text-lg"
                >
                    終止以您為要保人所投保之所有個人險有效及停效保單<br class="hidden md:inline">知悉並同意，終止後即改以書面方式進行通知。
                </span>
                <ChangeBeforeAfter
                    v-if="showBeforeAfter.mobile"
                    class="mt-2.5"
                    title="行動電話"
                >
                    <template #before>
                        <div class="ml-4">
                            <span v-if="data.before.mobileCountry">
                                {{ `(+${data.before.mobileCountry})` }}
                            </span> {{ data.before.fullMobile }}
                        </div>
                    </template>
                    <template #after>
                        <div class="ml-4">
                            <span v-if="data.after.mobileCountry">
                                {{ `(+${data.after.mobileCountry})` }}
                            </span> {{ data.after.fullMobile }}
                        </div>
                    </template>
                </ChangeBeforeAfter>
                <ChangeBeforeAfter
                    v-if="showBeforeAfter.email"
                    class="mt-2.5"
                    title="E-mail"
                >
                    <template #before>
                        <div class="ml-4">
                            {{ data.before.email }}
                        </div>
                    </template>
                    <template #after>
                        <div class="ml-4">
                            {{ data.after.email }}
                        </div>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { computed, ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'MultiENotifyData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('multiENotify');
        const showBeforeAfter = computed(() => {
            const obj = {};
            const { before, after } = data.value;
            obj.email = before.email !== after.email;
            obj.mobile = before.fullMobile !== after.fullMobile;
            return obj;
        });
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService, showBeforeAfter };
    },
};
</script>
